<script>
export default {
  props: {
    paginations: {
      type: Object,
      default: function() {
        return {
          page_no: 1,
          page_total: 1,
          count: 1,
          total_records: 1,
        }
      },
      require: true,
    },
    searching: {
      type: Boolean,
      default: false,
      require: false,
    },
    options: {
      type: Array,
      default: function() {
        return [{ value: '20' }, { value: '50' }, { value: '100' }]
      },
      require: false,
    },
  },
  data() {
    return {
      callbackBody: {},
      lines: 20,
    }
  },
  computed: {
    pagingComputed() {
      const generate = {}
      const { page_no: no, page_total: total, count } = this.paginations
      if (!count) {
        return generate
      }
      if (no !== 1) {
        if (total > 2 && no !== 2) {
          generate.pageOne = true
          if ((total === 4 && no === 4) || total > 4) {
            generate.middle = '...'
          }
        }
        generate.beforeNo = no - 1
      }

      if (no !== total) {
        generate.afterNo = no + 1
        if (total > 2 && no < total - 1) {
          if ((total === 4 && no === 1) || total > 4) {
            generate.beforeMiddle = '...'
          }
          generate.total = total
        }
      }
      return generate
    },
    counter() {
      const { page_no: no, page_total: total, count } = this.paginations
      if (!count) {
        return ''
      }
      if (this.searching) {
        if (no === total) {
          return `${(no - 1) * this.lines + 1} - ${count}`
        }
        return `${(no - 1) * this.lines + 1} - ${no * this.lines}`
      } else {
        if (no === total) {
          return `${(no - 1) * this.lines + 1} - ${count}/${count}`
        }
        return `${(no - 1) * this.lines + 1}-${no * this.lines}/${count}`
      }
    },
    numberOnTotal() {
      const { count, total_records: totalRecords } = this.paginations
      if (this.searching) {
        return `${count}/${totalRecords}`
      }
      return ''
    },
  },
  methods: {
    handleSearch(field, value, ok = true) {
      if (ok) {
        this.callbackBody = { ...this.callbackBody, [field]: value }
        if (field === 'lines') {
          this.callbackBody.page_no = 1
        }
        this.$emit('activePagination', this.callbackBody)
      }
    },
  },
}
</script>

<template>
  <CRow>
    <CCol md="6" sm="12" class="d-flex align-items-center flex-wrap">
      <slot name="secondary"></slot>
    </CCol>
    <CCol
      md="6"
      sm="12"
      class="align-self-end d-flex justify-content-end align-items-center flex-wrap"
    >
      ページあたりの表示件数 :
      <CSelect
        :options="options"
        :value.sync="lines"
        class="ml-2 mb-0"
        style="width: 100px"
        custom
        @update:value="(v) => handleSearch('lines', parseInt(v, 10))"
      />
      <div id="feelline-base-pagination" class="ml-2 d-flex">
        <div v-if="paginations.count">
          <CButton
            type="button"
            class="btn-link spacing-element"
            @click="
              () =>
                handleSearch(
                  'page_no',
                  paginations.page_no - 1,
                  paginations.page_no > 1
                )
            "
            >前</CButton
          >
          <CButton
            v-if="pagingComputed.pageOne"
            type="button"
            class="btn-link spacing-element"
            @click="() => handleSearch('page_no', 1)"
            >1</CButton
          >
          <label v-if="pagingComputed.middle" class="spacing-element"
            >...</label
          >
          <CButton
            v-if="pagingComputed.beforeNo"
            type="button"
            class="btn-link spacing-element"
            @click="
              () =>
                handleSearch(
                  'page_no',
                  paginations.page_no - 1,
                  paginations.page_no > 1
                )
            "
            >{{ paginations.page_no - 1 }}</CButton
          >
          <CButton type="button" class="btn-link spacing-element active-page">{{
            paginations.page_no
          }}</CButton>
          <CButton
            v-if="pagingComputed.afterNo"
            type="button"
            class="btn-link spacing-element"
            @click="
              () =>
                handleSearch(
                  'page_no',
                  paginations.page_no + 1,
                  paginations.page_no < paginations.page_total
                )
            "
            >{{ paginations.page_no + 1 }}</CButton
          >
          <label v-if="pagingComputed.beforeMiddle" class="spacing-element"
            >...</label
          >
          <CButton
            v-if="pagingComputed.total"
            type="button"
            class="btn-link spacing-element"
            @click="() => handleSearch('page_no', paginations.page_total)"
            >{{ paginations.page_total }}</CButton
          >
          <CButton
            type="button"
            class="btn-link spacing-element"
            @click="
              () =>
                handleSearch(
                  'page_no',
                  paginations.page_no + 1,
                  paginations.page_no < paginations.page_total
                )
            "
            >次</CButton
          >
        </div>
        <CButton class="spacing-element ml-1">
          {{ counter }}<span v-if="searching" class="mr-2"></span>
          {{ numberOnTotal }}
        </CButton>
      </div>
    </CCol>
  </CRow>
</template>

<style lang="scss" scoped>
#feelline-base-pagination {
  * {
    font-size: $h5-font-size;
  }
  .btn {
    padding: 0.375rem 0.25rem;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .spacing-element {
    width: auto;
    padding: 1px;
    margin: 0;
  }
  .active-page {
    color: #b3b3b3;
  }
}
</style>
